import { render } from "./ArtistAreaChart.vue?vue&type=template&id=a85daf0c&scoped=true"
import script from "./ArtistAreaChart.vue?vue&type=script&lang=js"
export * from "./ArtistAreaChart.vue?vue&type=script&lang=js"

import "./ArtistAreaChart.vue?vue&type=style&index=0&id=a85daf0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85daf0c"]])

export default __exports__